// Sidebar.jsx
import React from 'react';
import {
  Home,
  Calendar,
  MapPin,
  Users,
  FileText,
  BarChart3,
  Zap,
  Target,
  Activity,
} from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../../theme/ThemeContext';

const navItems = [
  { label: 'Dashboard', icon: Home, to: '/dashboard' },
  { label: 'Schedule Runs', icon: Calendar, to: '/schedule-runs' },
  { label: 'Visits', icon: MapPin, to: '/visits' },
  { label: 'Guards', icon: Users, to: '/guards' },
  {label:'Clients',icon: Users, to:'/clients'},
  { label: 'Properties', icon: FileText, to: '/properties' },
  { label: 'Reports', icon: BarChart3, to: '/reports' },
];

const featureItems = [
  { label: 'AI Insights', icon: Zap, badge: 'New', to: '/featuresworks' },
  { label: 'Route Optimizer', icon: Target, to: '/featuresworks' },
  { label: 'Live Tracking', icon: Activity, to: '/featuresworks' },
];

const Sidebar = ({ isMobileOpen, isCollapsed }) => {
  const { theme } = useTheme();

  return (
    <aside
      className={`fixed lg:static inset-y-0 left-0 transform ${
        isMobileOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0 z-30 bg-white border-r border-slate-200 pt-16 lg:pt-0
      w-64 ${isCollapsed ? 'lg:w-20' : 'lg:w-64'}
      transition-[width,transform] duration-300 ease-in-out`}
    >
      <nav className="h-full flex flex-col p-4 space-y-2">
        {/* top nav */}
        <div className="space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.label}
                to={item.to}
                title={isCollapsed ? item.label : undefined}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                    isActive
                      ? 'font-medium shadow-md'
                      : 'text-slate-600 hover:bg-slate-50'
                  }`
                }
                style={({ isActive }) =>
                  isActive
                    ? {
                        background: `linear-gradient(to right, ${theme.primary[50]}, ${theme.secondary[50]})`,
                        color: theme.primary[700],
                      }
                    : undefined
                }
              >
                <Icon className="w-5 h-5" />
                {!isCollapsed && <span>{item.label}</span>}
              </NavLink>
            );
          })}
        </div>

        {/* features */}
        <div className="pt-4 mt-4 border-t border-slate-200 flex-1">
          {!isCollapsed && (
            <p className="px-4 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">
              Software Features
            </p>
          )}

          {featureItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.label}
                to={item.to}
                title={isCollapsed ? item.label : undefined}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                    isActive
                      ? 'font-medium shadow-md'
                      : 'text-slate-600 hover:bg-slate-50'
                  }`
                }
                style={({ isActive }) =>
                  isActive
                    ? {
                        background: `linear-gradient(to right, ${theme.primary[50]}, ${theme.secondary[50]})`,
                        color: theme.primary[700],
                      }
                    : undefined
                }
              >
                <Icon className="w-5 h-5" />
                {!isCollapsed && <span>{item.label}</span>}
                {!isCollapsed && item.badge && (
                  <span
                    className="ml-auto px-2 py-0.5 text-xs rounded-full font-semibold"
                    style={{
                      backgroundColor: `${theme.primary[100]}`,
                      color: theme.primary[700],
                    }}
                  >
                    {item.badge}
                  </span>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;
